import _constant from 'lodash/constant'; // Constants

import { EMPTY_OBJECT } from 'tbase/app.constants';

var createReducer = function createReducer() {
  var actionHandlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return function (state, action) {
    var type = action.type;

    var handler = actionHandlers[type] || _constant(state);

    return handler(state, action);
  };
};

export default createReducer;